export function calcularBonificacionEstatica({ precioOriginal, bonificaciones }){
  let precio = precioOriginal;
  bonificaciones.forEach((bonificacion) => {
    const { valor, tipoCadena } = bonificacion;
    switch (tipoCadena) {
      case 'porcentaje_descuento':
        precio -= precio * valor / 100;
        break;
      case 'precio_fijo':
        precio = valor;
        break;
      case 'importe_descuento':
        precio -= valor;
        break;
    }
  });
  if (precio < 0) {
    precio = 0;
  }
  return precio;
}
export function calcularBonificacionVariable({ precioOriginal, bonificacion }){
  let precio = precioOriginal;
  const { cantidad, tipo } = bonificacion;
  if (cantidad && cantidad > 0) {
    if (tipo === 'importe') precio -= cantidad;
    else precio -= precio * cantidad / 100;
  }
  return precio;
}